
<template>
  <div>
    <el-container>
      <el-aside width="250px">
        <Group group-type="D1402" />
      </el-aside>
      <el-container>
        <el-main>Main</el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import Group from '@/views/managesystem/td/td03/group.vue'
export default {
  components: {
    Group
  },
  props: {},
  data() {
    return {
      title: '项目组'

    }
  },
  computed: {},
  watch: {},
  created() { },
  mounted() { },
  methods: {
  }
}
</script>

